export { getDefaultActivity } from "@rebuild/shared";

export function normalizeLineItemToLowerCase(lineItem: string): string {
  return lineItem.replace(/\s/g, "").trim().toLowerCase();
}
